import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import { useParams } from "react-router-dom";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import cleanURL from "../../common/cleanURL";
import RenderItem from "../../common/renderItem";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "react-loader-spinner";
import { useMediaQuery } from "react-responsive";
import {
  UpdateCartCount,
  UpdateCartAmount,
} from "../../redux/actions/postActions";
import ContentLoader from "react-content-loader";
import {
  KMTracking,
  campaignRecord,
} from "../../components/Tracking/KMTracking";
import JustMerchants from "../../common/constants";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import ProgressBar from "@ramonak/react-progress-bar";
// import Loader from '../../common/loader'

const MyLoader = () => (
  // document.querySelector(".query")."hide");
  <ContentLoader viewBox="0 0 1000 400">
    <rect x="3" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="350" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="700" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="3" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="350" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="700" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="3" y="330" rx="4" ry="4" width="175" height="28" />
    <rect x="3" y="371" rx="4" ry="4" width="131" height="33" />
    <rect x="350" y="330" rx="4" ry="4" width="300" height="29" />
    <rect x="350" y="371" rx="4" ry="4" width="116" height="30" />
    <rect x="700" y="330" rx="4" ry="4" width="173" height="29" />
    <rect x="700" y="371" rx="4" ry="4" width="200" height="31" />
  </ContentLoader>
);
function Brand(props) {
  const [merchants, setMerchants] = useState<any>([]);
  const [selectedBrand, setSelectBrand] = useState<any>("");
  const [parentmerchants, setParentmerchants] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [categories, setCategories] = useState([]);
  const [sideDrawerVisible, setSideDrawerVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>("");
  const [productCount, setProductCount] = useState(0);
  const [moreProductsAvailable, setMoreProductsAvailable] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [allProductLength, setAllProductLength] = useState("");
  const [loader, setLoader] = useState(false);
  const [DeliveryID,setDeliveryID]= useState("")
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const brand = cleanURL(props?.match?.params?.brandName);
  let brandID = props?.match?.params?.brandID;
  if (brandID?.includes("?")) {
    brandID = brandID?.split("?");
    brandID = brandID[0];
  }
  console.log("Checking brand name", props?.match?.params);
  if (brand == "Delivery" || brand == "delivery") {
    props?.history.push("/home");
  }
  const sortOptions = [
    { id: 1, label: "Name", value: "name" },
    { id: 2, label: "Latest", value: "-created" },
    { id: 3, label: "Price Low to High", value: "price" },
    { id: 4, label: "Price High to Low", value: "-price" },
  ];
  const [sortBy, setSortBy] = useState<any>(sortOptions[0]);
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    let ACFData:any = localStorage.getItem("ACF")
    let Deliveryid =JSON.parse(ACFData)?.FrasersDeliveryItemID
    setDeliveryID(Deliveryid)
    let brand1 = cleanURL(props?.match?.params?.brandName);

    if (brand1 !== "" || brand1 !== undefined) {
      setSelectedCategory(brand1);
    } else {
      setSelectedCategory(brand);
    }
    setSelectedCategory(brand);
    console.log("**&&&& props.location.", props.location);
    props.location.search &&
      campaignRecord(props.location.search, props.location.pathname);
  }, []);
  useEffect(() => {
    const data = {
      "Current Page": "BrandProducts",
      "Brand Name": brand.replace(/-/g, " "),
      "Source Page": props?.location?.state?.from
        ? props?.location?.state?.from
        : "",
    };
    tracker("pageviewed", data);
    window.scrollTo(0, 0);
    setIsLoading(true);
    getMerchants(brandID);
    let brand1 = props?.match?.params?.brandName;
    if (brand1 !== "" || brand1 !== undefined) {
      setSelectedCategory(brand1);
    } else {
      setSelectedCategory(brand);
    }
  }, [sortBy, brand]);
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const getMerchants = async (brandID) => {
    await new WebApiCalls().getAllMerchants().then((response) => {
      if (response && response.body && response.body.Records) {
        let tempList = response.body.Records.filter(
          (item) => item.DisplayName != ""
        );
        tempList?.map((item) => {
          if (item.ID == brandID) {
            const BannerImage = item?.CustomFields
              ? item?.CustomFields?.length > 0
                ? item?.CustomFields?.filter((item2) =>
                    item2?.Name?.includes("BannerURL")
                  ).length > 0
                  ? item?.CustomFields?.filter((item2) =>
                      item2?.Name?.includes("BannerURL")
                    )[0].Values[0]
                  : ""
                : ""
              : "";
            item.mall = item.CustomFields
              ? item.CustomFields.filter((response) =>
                  response.Name.includes("Mall")
                ).length > 0
                ? item.CustomFields.filter((response) =>
                    response.Name.includes("Mall")
                  )[0].Values[0]
                : ""
              : "";
            item.unit = item.CustomFields
              ? item.CustomFields.filter((response) =>
                  response.Name.includes("Unit Number")
                ).length > 0
                ? item.CustomFields.filter((response) =>
                    response.Name.includes("Unit Number")
                  )[0].Values[0]
                : ""
              : "";
            item.BannerURL = BannerImage;
            setSelectBrand(item);
            JustMerchants(item.ID).then((result) => {
              let data = {
                "Mall Name": result["MallName"],
                "Store Name": result["StoreName"],
              };
              tracker("viewedstorepage", data);
            });
            setPageNumber(1);
            getProducts(1, item.ID);
          }
        });
        /**Added by Nauman */
        let sorted = response?.body?.Records.sort((a, b) =>
          a.DisplayName.toLowerCase() > b.DisplayName.toLowerCase()
            ? 1
            : b.DisplayName.toLowerCase() > a.DisplayName.toLowerCase()
            ? -1
            : 0
        );
        // sorted && (console.log(""));
        setMerchants(sorted);
      }
    });
  };
  const getProducts = async (pageNumber: number, brand_id: number) => {
    let _products: any = [];
    let itemObj = {
      sellerID: brand_id ? brand_id : selectedBrand.ID,
      pageSize: 20,
      Sort: sortBy?.value ? sortBy.value : "name",
      pageNumber: pageNumber ? pageNumber : 1,
    };
    await new WebApiCalls().getItemsByFilters(itemObj).then((response) => {
      setAllProductLength(response.TotalRecords);
      if (productCount == response.Records.length) {
        setProductCount(response.Records.length + 1);
        setLoader(false);
      } else {
        setProductCount(response.Records.length);
        setLoader(false);
      }
      if (response?.Records?.length > 0) {
        setProductCount(response?.Records?.length);
        response?.Records?.map((item) => {
          if (
            item?.ID == DeliveryID
          ) {
            return;
          } else {
            if (item) {
              _products = [..._products, item];
            }
          }
        });
        if (pageNumber == 1) {
          setProducts(_products);
          setIsLoading(false);
        } else {
          setProducts(products.concat(_products));
          setIsLoading(false);
        }
      } else {
        setMoreProductsAvailable(false);
        setIsLoading(false);
      }
    });
  };
  const onClickItem = (_item) => {
    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "Brand",
    });
  };
  // mainreturn
  return (
    <div>
      <Helmet>
        <meta
          property="og:title"
          content={selectedBrand?.DisplayName}
          data-rh="true"
        />
        <meta
          property="og:description"
          content={`${selectedBrand?.unit} ${selectedBrand?.mall}`}
          data-rh="true"
        />
        <meta
          property="og:image"
          content={selectedBrand?.BannerURL}
          data-rh="true"
        ></meta>
      </Helmet>
      <div className="viewport"></div>
      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}
        <div
          className={`main-overlay ${sideDrawerVisible ? "active" : ""}`}
          onClick={() => {
            setSideDrawerVisible(!sideDrawerVisible);
          }}
        ></div>
        {/* mainmenu */}
        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />
        {/* /mainmenu */}

        {/* /content */}
        <div className="content">
          {/* breadcrumb */}
          <div
            className="breadcrumb"
            style={{ backgroundColor: "rgb(255,255,255,0.3)" }}
          >
            <Link to="/">Home</Link>
            <a>{selectedBrand?.DisplayName}</a>
          </div>
          {/* /breadcrumb */}

          {/* category hero */}
          <div className="category-hero">
            <div className="thumb">
              <div className="overlay"></div>
              <img src={selectedBrand?.BannerURL} alt="" />
            </div>
            <div className="text">
              <div className="title">{selectedBrand?.DisplayName}</div>
              {selectedBrand?.unit && selectedBrand?.mall && (
                <div
                  style={{
                    display:
                      isTabletOrMobileDevice || isTabletOrMobile ? "block" : "",
                  }}
                  className="sub"
                >{`${selectedBrand?.unit} ${selectedBrand?.mall}`}</div>
              )}
            </div>
          </div>
          {/* /category hero */}

          {/* product listing */}
          <div className="product-listing">
            {/* filter */}
            <div className="filter">
              <div className="text">Sort by</div>
              <select
                value={sortBy.value}
                name="sortby"
                id="sortby"
                onChange={(e: any) => {
                  setPageNumber(1);
                  let selecteOption = sortOptions.find(
                    (option) => option.value == e.target.value
                  );
                  setSortBy(selecteOption);
                  let kmFilterValuesProps = {
                    "Filter Type": "SORT BY",
                    "Sort Value": selecteOption,
                  };
                  tracker("appliedfilter", kmFilterValuesProps);
                }}
              >
                {sortOptions?.map((item: any, index) => {
                  return (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* /filter */}

            {/* sub-categories (mobile) */}
            <div
              className="sub-categories mobile-only"
              onClick={() => {
                setSideDrawerVisible(true);
              }}
            >
              <div className="" style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "7",
                  }}
                >
                  <div className="title">BRAND</div>
                  <div
                    className="text"
                    style={{ fontSize: "14px", color: "black" }}
                  >
                    <strong>{selectedBrand?.DisplayName}</strong>
                  </div>
                </div>
                <div
                  className="img"
                  style={{ display: "flex", flex: "1", alignItems: "flex-end" }}
                >
                  <img
                    style={{ maxWidth: "15px" }}
                    src={process.env.PUBLIC_URL + "/images/downward_icon.png"}
                  />
                </div>
              </div>

              {/* <select name="sub-categories" id="sub-categories" defaultValue={selectedCategory?.replace(/_/g, " ")}>
                                <option value="" className="query" style={{ fontWeight: "bold", color: "black", border: "1px solid red" }}>{selectedCategory?.replace(/_/g, " ")}</option> */}
              {/* <option value="">Computing & Accessories</option>
                                <option value="">Phones & Accessories</option>
                                <option value="">Wearables & Smart Home</option>
                                <option value="">TV & Projector</option>
                                <option value="">Home Appliances</option>
                                <option value="">Headphones, Speakers & Audio</option>
                                <option value="">Camera & Drones</option> */}
              {/* </select> */}
            </div>

            {/* /sub-categories (mobile) */}

            {/* <div className="bg-darken" onClick={() => setSideDrawerVisible(false)}></div> */}
            <div
              className={`slide-categories ${
                sideDrawerVisible ? "active" : ""
              }`}
            >
              <div className="title">BRAND</div>

              <dl className="accordion show">
                {merchants?.map((item: any, index) => {
                  if (item.DisplayName == "") {
                    return;
                  }
                  if (item.DisplayName.includes("delivery")) {
                    return;
                  }
                  if (item.Media.length < 1) {
                    return;
                  }

                  return (
                    <>
                      <dt className="active" key={index}>
                        <Link
                          to={`/brand/${cleanURL(item.DisplayName)}/${item.ID}`}
                          onClick={() => {
                            props?.history?.push(
                              `/brand/${cleanURL(item.DisplayName)}/${item.ID}`
                            );
                            setSideDrawerVisible(false);
                            setSelectedCategory(item.DisplayName);
                          }}
                        >
                          {item?.DisplayName}
                        </Link>
                      </dt>
                      {/* {item?.ChildItems?.map((item2, index2)=>{
                                                return (
                                                    <>
                                                    <dd key={index2}>
                                                    <a    >{item2.Name}</a>
                                                </dd></>
                                                )
                                            })} */}
                    </>
                  );
                })}
              </dl>
            </div>
            {/* /slide-categories */}

            {/* two-columns */}
            {is_loading ? (
              <MyLoader />
            ) : (
              <div className="two-columns">
                {/* /products */}
                <div>
                  <div className="products full" style={{ width: "100%" }}>
                    {products?.map((item: any, index: number) => {
                      return (
                        <RenderItem
                          key={index}
                          custom_style={{}}
                          is_slider={false}
                          item={item}
                          onClickItem={onClickItem}
                          from={"Brand"}
                        />
                      );
                    })}
                  </div>
                  {products.length > 0 ? (
                    <div>
                      <div
                        style={{ textAlign: "center", marginTop: "4px" }}
                        className="load-more-sec"
                      >
                        <div
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: "11px",
                            lineHeight: "20px",
                            color: "#666",
                          }}
                        >
                          {`You've viewed ${products.length} of ${allProductLength}
                          products`}
                        </div>
                        <ProgressBar
                          className="progress-bar"
                          isLabelVisible={false}
                          maxCompleted={parseInt(allProductLength)}
                          completed={products.length}
                          height="2px"
                          width="100%"
                          bgColor="#000000"
                        />
                      </div>
                      {parseInt(allProductLength) !== products.length && (
                        <div
                          style={{
                            textAlign: "center",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          {!loader ? (
                            <button
                              style={{
                                fontFamily: "Montserrat",
                                fontSize: "12px",
                                backgroundColor: "#ffffff",
                                color: "#000000",
                                padding: "10px 60px",
                                border: "1px solid #DDDDDD",
                                cursor: "pointer",
                                letterSpacing: "1.5px",
                                fontWeight: 500,
                              }}
                              onClick={() => {
                                let page = pageNumber + 1;
                                setPageNumber(page);
                                if (selectedBrand !== "") {
                                  getProducts(page, selectedBrand.ID);
                                  setLoader(true);
                                }
                              }}
                              className="btn btn-primary"
                            >
                              LOAD MORE
                            </button>
                          ) : (
                            <SpinnerCircular
                              color="black"
                              size="33"
                              thickness={170}
                              speed={200}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="products">
                      <br />
                      There are currently no products in this category.
                      <br />
                      Please check again later.
                    </div>
                  )}
                </div>
                {/* /products */}
              </div>
            )}
            {/* /two-columns */}
          </div>
          {/* /product listing */}
        </div>
        {/* /content*/}
      </div>
      {/* /container */}

      {/* footer */}
      <Footer props={props} />
      {/* /footer */}
      <a onClick={() => window.scrollTo(0, 0)} className="btt">
        <img src="images/uparrow.svg" alt="" />
      </a>
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, allCategories } = state.UserReducer;
  return { cart_count, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
};
export default connect(mapStateToProps, actions)(Brand);
